import { ProjectConfig } from '@contember/admin'
import { routes } from './routes'

export const config: ProjectConfig = {
	project: 'abstmolen',
	stage: 'live',
	component: () => import('./component'),
	routes,
}
